<template>
    <v-dialog v-model="isOpen" width="500">
        <v-card class="py-4" width="500">
            <v-card-title class="mb-4">
                <h2 class="font-weight-light red--text">Tienes turnos por completar</h2>
            </v-card-title>
            <v-card-text>
                <v-card
                    flat
                    tile
                >
                    <v-window
                        v-model="onboarding"
                        vertical
                        v-if="invalidPunchIn"
                    >
                        <v-window-item
                            v-for="n in invalidPunchIn.length"
                            :key="`card-${n}`"
                        >
                            <PunchDailyView :day="getDay(n)" :punch="getPunch(n)"/>
                        </v-window-item>
                    </v-window>

                    <v-card-actions class="justify-space-between">
                        <v-btn
                            text
                            @click="prev"
                        >
                            <v-icon>mdi-chevron-left</v-icon>
                        </v-btn>
                        <v-item-group
                            v-model="onboarding"
                            class="text-center"
                            mandatory
                            v-if="invalidPunchIn"
                        >
                            <v-item
                            v-for="n in invalidPunchIn.length"
                            :key="`btn-${n}`"
                            v-slot="{ active, toggle }"
                            >
                                <v-btn
                                    :input-value="active"
                                    icon
                                    @click="toggle"
                                >
                                    <v-icon>mdi-record</v-icon>
                                </v-btn>
                            </v-item>
                        </v-item-group>
                        <v-btn
                            text
                            @click="next"
                        >
                            <v-icon>mdi-chevron-right</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-text>
            <v-card-actions class="my-n6 pa-4">
                <v-spacer></v-spacer>
                <v-btn text color="red" @click="isOpen=false" small>cerrar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import PunchDailyView from './PunchInDailyView.vue'

export default {
    name: "PunchInToComplete",
    data: () => ({
        onboarding: 0,
        isOpen: false
    }),
    components: {
        PunchDailyView
    },
    methods: {
        next () {
            this.onboarding = this.onboarding + 1 === this?.invalidPunchIn.length
            ? 0
            : this.onboarding + 1
        },
        prev () {
            this.onboarding = this.onboarding - 1 < 0
            ? this.invalidPunchIn?.length - 1
            : this.onboarding - 1
        },
        getPunch(index){
            console.log(this.invalidPunchIn[index-1])
            return this.invalidPunchIn[index-1]
        },
        getDay(index){
            return new Date(this.invalidPunchIn[index-1]?.date)
        }
    },
    computed: {
        invalidPunchIn() {
            return JSON.parse(localStorage.getItem('invalidPunchIn'));
        },
    },
    beforeMount(){
        this.isOpen = this.invalidPunchIn?.length > 0    
    },
}
</script>
